export const constants={
    homeRoute:'/home',
    aboutRoute:'/about',
    serviceRoute:'/service',
    priceRoute:'/price'
}